import '../layout/Header/Header.css';
import './Defaults.css';
import React from 'react';
import ProductsBreadCrumbs from '../productPage/tableComponents/ProductsBreadCrumbs';
import ReusableTabs from '../common/ReusableTabs';
import investorRelationHeaderImage from '../../static/investor_image/investorHeader.png';
import * as styles from '../productPage/tableComponents/ProductPage_style';
import { toUrl } from '@/utils/convertImagePath';

const DesignRegistration: React.FC = () => {
    return (
        <ReusableTabs
            backgroundColor="#ffffff"
            bannerImage={toUrl(investorRelationHeaderImage)}
            bannerTitle="Design Registration Product Listing"
            bannerDescription=""
            tabLabels={[]}
            tabKeys={['']}
            tabContents={[
                <div key="design-registration-content" className="mid-width">
                    <div className="html-pages-wrapper">
                        <div dangerouslySetInnerHTML={{ __html: html }} />
                    </div>
                </div>,
            ]}
            bannerFontStyle={styles.bannerFont}
            subBannerFontStyle={styles.bannerFont2}
            pageName={'browseAllProductHome'}
            showTabs={false}
            breadcrumbs={
                <ProductsBreadCrumbs
                    breadCrumbs={[
                        {
                            name: 'Sales & Resources',
                        },
                        {
                            name: 'Design Registration Product Listing',
                            url: `/SalesResources/DesignRegistrationProductListing`,
                        },
                    ]}
                />
            }
        />
    );
};

export default DesignRegistration;

const html = `<div class="datasheet-tab"><div class="datasheet-tab__wrapper">
    
    <div id="datasheet-menu" class="datasheet-tab__container">
        <a name="mobile-anchor" class="datasheet-menu mobile">
            <span id="datasheet-menu-mobile-anchor"></span>
        </a>
        <div class="datasheet-menu" data-sticky-container="">
            
            <div data-top-anchor="datasheet-menu:top" data-margin-top="4.5" data-sticky-on="large" class="datasheet-menu__container sticky is-at-top" data-check-every="1" data-sticky="" data-btm-anchor="datasheet-menu:bottom">
                <div>
<div data-multi-expand="true" data-allow-all-closed="false" data-accordion="" class="datasheet-menu__accordion accordion datasheet-desktop">
    <div data-accordion-item="" class="datasheet-menu__accordion-item accordion-item">
        <h6 class="datasheet-menu__title">JUMP TO PRODUCT GROUP</h6>
        <a href="#" class="datasheet-menu__accordion-title accordion-title">JUMP TO PRODUCT GROUP</a>
        <div class="datasheet-menu__accordion-content accordion-content" data-tab-content="">
            <div class="datasheet-menu__list">
                <a href="#C1" class="datasheet-menu__subtitle" data-smooth-scroll="">Antennas, RF, &amp; Microwave</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a data-smooth-scroll="" class="datasheet-menu__subtitle" href="#C2">Cable Harnesses</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a href="#C3" data-smooth-scroll="" class="datasheet-menu__subtitle">Capacitors</a>
                <ul>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C4">
                                Aluminum
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C5">
                                Ceramic
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C6" data-smooth-scroll="">
                                Film
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C7">
                                Polymer
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C8">
                                Supercapacitors
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C9">
                                Tantalum
                            </a>
                        </li>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a href="#C10" class="datasheet-menu__subtitle" data-smooth-scroll="">Circuit Protection</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a href="#C11" data-smooth-scroll="" class="datasheet-menu__subtitle">Discrete Semiconductors</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a href="#C12" class="datasheet-menu__subtitle" data-smooth-scroll="">EMC Products</a>
                <ul>
                    
                        <li>
                            <a href="#C13" data-smooth-scroll="">
                                Common Mode Chokes - Power
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C14" data-smooth-scroll="">
                                Common Mode Chokes - Signal
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C15">
                                Differential Mode Chokes - Power
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C16">
                                Differential Mode Chokes - Signal
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C17" data-smooth-scroll="">
                                Dual Mode Chokes
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C18" data-smooth-scroll="">
                                EMI Filters
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C19" data-smooth-scroll="">
                                EMI Suppression
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C20">
                                Ground Wires
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C21" data-smooth-scroll="">
                                Magnetic Materials
                            </a>
                        </li>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a data-smooth-scroll="" href="#C22" class="datasheet-menu__subtitle">Electromechanical</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a data-smooth-scroll="" href="#C23" class="datasheet-menu__subtitle">Inductors</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a data-smooth-scroll="" href="#C24" class="datasheet-menu__subtitle">Motor &amp; Ignition Coils</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a href="#C25" class="datasheet-menu__subtitle" data-smooth-scroll="">Piezoelectric</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a href="#C26" class="datasheet-menu__subtitle" data-smooth-scroll="">Power Supplies</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a data-smooth-scroll="" class="datasheet-menu__subtitle" href="#C27">Resistors</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a class="datasheet-menu__subtitle" href="#C28" data-smooth-scroll="">Sensors</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a class="datasheet-menu__subtitle" href="#C29" data-smooth-scroll="">Signal Magnetics &amp; Connectors</a>
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list">
                <a class="datasheet-menu__subtitle" href="#C30" data-smooth-scroll="">Transformers</a>
                <ul>
                    
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="datasheet-menu__accordion accordion datasheet-mobile" data-multi-expand="true" data-allow-all-closed="true" data-accordion="">
    <div class="datasheet-menu__accordion-item accordion-item" data-accordion-item="">
        <h6 class="datasheet-menu__title">JUMP TO PRODUCT GROUP</h6>
        <a class="datasheet-menu__accordion-title accordion-title" href="#">JUMP TO PRODUCT GROUP</a>
        <div class="datasheet-menu__accordion-content accordion-content" data-tab-content="">
            <div class="datasheet-menu__list mobile_list">
                <a class="datasheet-menu__subtitle" href="#C1" data-smooth-scroll="">Antennas, RF, &amp; Microwave</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a href="#C2" class="datasheet-menu__subtitle" data-smooth-scroll="">Cable Harnesses</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a href="#C3" data-smooth-scroll="" class="datasheet-menu__subtitle">Capacitors</a>
                
                <ul>
                    
                        <li>
                            <a href="#C4" data-smooth-scroll="">
                                Aluminum
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C5" data-smooth-scroll="">
                                Ceramic
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C6" data-smooth-scroll="">
                                Film
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C7">
                                Polymer
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C8">
                                Supercapacitors
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C9">
                                Tantalum
                            </a>
                        </li>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a data-smooth-scroll="" class="datasheet-menu__subtitle" href="#C10">Circuit Protection</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a data-smooth-scroll="" class="datasheet-menu__subtitle" href="#C11">Discrete Semiconductors</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a href="#C12" data-smooth-scroll="" class="datasheet-menu__subtitle">EMC Products</a>
                
                <ul>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C13">
                                Common Mode Chokes - Power
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C14" data-smooth-scroll="">
                                Common Mode Chokes - Signal
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C15">
                                Differential Mode Chokes - Power
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C16">
                                Differential Mode Chokes - Signal
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C17" data-smooth-scroll="">
                                Dual Mode Chokes
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C18" data-smooth-scroll="">
                                EMI Filters
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C19" data-smooth-scroll="">
                                EMI Suppression
                            </a>
                        </li>
                    
                        <li>
                            <a href="#C20" data-smooth-scroll="">
                                Ground Wires
                            </a>
                        </li>
                    
                        <li>
                            <a data-smooth-scroll="" href="#C21">
                                Magnetic Materials
                            </a>
                        </li>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a data-smooth-scroll="" href="#C22" class="datasheet-menu__subtitle">Electromechanical</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a class="datasheet-menu__subtitle" data-smooth-scroll="" href="#C23">Inductors</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a data-smooth-scroll="" class="datasheet-menu__subtitle" href="#C24">Motor &amp; Ignition Coils</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a class="datasheet-menu__subtitle" data-smooth-scroll="" href="#C25">Piezoelectric</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a class="datasheet-menu__subtitle" href="#C26" data-smooth-scroll="">Power Supplies</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a data-smooth-scroll="" class="datasheet-menu__subtitle" href="#C27">Resistors</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a href="#C28" class="datasheet-menu__subtitle" data-smooth-scroll="">Sensors</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a data-smooth-scroll="" class="datasheet-menu__subtitle" href="#C29">Signal Magnetics &amp; Connectors</a>
                
                <ul>
                    
                </ul>
            </div>
        
            <div class="datasheet-menu__list mobile_list">
                <a data-smooth-scroll="" href="#C30" class="datasheet-menu__subtitle">Transformers</a>
                
                <ul>
                    
                </ul>
            </div>
        </div>
    </div>
</div>

</div>
            </div>
        </div>
        <div class="datasheet-content">
            




    
    
    <div class="rte">
<div class="rte-wrapper   ">
        <p><span style="font-weight: normal;">To view the list of design registration products, use the navigation panel on the left to jump to a specific product group, or scroll down the page.</span></p>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span class="section-anchor" id="C1"> </span>
    Antennas, RF, &amp; Microwave
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellpadding="1" width="1080" border="0" cellspacing="0">
<tbody><tr><th style="text-align: left;" scope="col" width="45%">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th width="10%" scope="col" style="text-align: left;">Brand</th>
</tr><tr><td>Antennas</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Connectors, Cables, &amp; Mounts</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Couplers</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Custom</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>RF Filter</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Splitters</td>
<td>All</td>
<td>Pulse</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span id="C2" class="section-anchor"> </span>
    Cable Harnesses
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellspacing="0" cellpadding="1" border="0" width="1080">
<tbody><tr><th width="45%" scope="col" style="text-align: left;">Description</th>
<th style="text-align: left;" scope="col">Series</th>
<th width="10%" scope="col" style="text-align: left;">Brand</th>
</tr><tr><td>Custom</td>
<td>All</td>
<td>Pulse</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span class="section-anchor" id="C3"> </span>
    Capacitors
</h2>
</div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C4" class="section-anchor"> </span>
    Aluminum
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table width="1080" cellpadding="1" border="0" cellspacing="0">
<tbody><tr><th style="text-align: left;" scope="col" width="45%">Description</th>
<th style="text-align: left;" scope="col">Series</th>
<th style="text-align: left;" width="10%" scope="col">Brand</th>
</tr><tr><td>Axial PEG124</td>
<td>A140, A141, A142, A149</td>
<td>KEMET</td>
</tr><tr><td>Axial PEG130</td>
<td>A152</td>
<td>KEMET</td>
</tr><tr><td>Axial PEG236</td>
<td>A200</td>
<td>KEMET</td>
</tr><tr><td>Axial PEG127</td>
<td>A241, A249</td>
<td>KEMET</td>
</tr><tr><td>Axial PEG227</td>
<td>A270</td>
<td>KEMET</td>
</tr><tr><td>Radial Crown SMD PES227</td>
<td>A272</td>
<td>KEMET</td>
</tr><tr><td>Radial Crown SMD PEV227</td>
<td>A274</td>
<td>KEMET</td>
</tr><tr><td>Axial PEG228</td>
<td>A280</td>
<td>KEMET</td>
</tr><tr><td>Radial Crown SMD PES228</td>
<td>A282</td>
<td>KEMET</td>
</tr><tr><td>Radial Crown SMD PEV228</td>
<td>A284</td>
<td>KEMET</td>
</tr><tr><td>Double Crown PED225</td>
<td>A258</td>
<td>KEMET</td>
</tr><tr><td>Screw Terminal PEH200</td>
<td>A351, A352, A359, A451, A452, A459, A479</td>
<td>KEMET</td>
</tr><tr><td>Screw Terminal PEH205</td>
<td>A361, A461</td>
<td>KEMET</td>
</tr><tr><td>Screw Terminal PEH169 85°C</td>
<td>A371, A471</td>
<td>KEMET</td>
</tr><tr><td>Screw Terminal PEH169 105°C</td>
<td>A372, A472</td>
<td>KEMET</td>
</tr><tr><td>Screw Terminal ALS80/81</td>
<td>A381, A481</td>
<td>KEMET</td>
</tr><tr><td>Screw Terminal ALS70/71</td>
<td>A390, A490</td>
<td>KEMET</td>
</tr><tr><td>Snap-In ALA7D</td>
<td>A542</td>
<td>KEMET</td>
</tr><tr><td>Snap-In ALA8D</td>
<td>A543</td>
<td>KEMET</td>
</tr><tr><td>Snap-In ALC70</td>
<td>A546</td>
<td>KEMET</td>
</tr><tr><td>Snap-In ALC80</td>
<td>A547</td>
<td>KEMET</td>
</tr><tr><td>Snap-In ALA7A</td>
<td>A552</td>
<td>KEMET</td>
</tr><tr><td>Snap-In ALA8A</td>
<td>A553</td>
<td>KEMET</td>
</tr><tr><td>Snap-In ALO8A</td>
<td>A572</td>
<td>KEMET</td>
</tr><tr><td>Press-Fit ALF70</td>
<td>A556</td>
<td>KEMET</td>
</tr><tr><td>Press-Fit ALF80</td>
<td>A557</td>
<td>KEMET</td>
</tr><tr><td>Snap-In ALH82</td>
<td>A562</td>
<td>KEMET</td>
</tr><tr><td>Snap-In ALV70</td>
<td>A570</td>
<td>KEMET</td>
</tr><tr><td>Snap-In PEH526</td>
<td>A581</td>
<td>KEMET</td>
</tr><tr><td>Radial Crown PEH236</td>
<td>A800</td>
<td>KEMET</td>
</tr><tr><td>Radial Crown PEH227</td>
<td>A870</td>
<td>KEMET</td>
</tr><tr><td>Radial Crown PEH228</td>
<td>A880</td>
<td>KEMET</td>
</tr><tr><td>Rectangular AAR70</td>
<td>A970</td>
<td>KEMET</td>
</tr><tr><td>Rectangular AAR7V</td>
<td>A972</td>
<td>KEMET</td>
</tr><tr><td>Rectangular AAR80</td>
<td>A980</td>
<td>KEMET</td>
</tr><tr><td>Rectangular AAR8S</td>
<td>A983</td>
<td>KEMET</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C5" class="section-anchor"> </span>
    Ceramic
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellpadding="1" border="0" cellspacing="0" width="1080">
<tbody><tr><th width="45%" scope="col" style="text-align: left;">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th width="10%" scope="col" style="text-align: left;">Brand</th>
</tr><tr><td>Commercial High Voltage SMD 500V-10kV</td>
<td>C0402-C4540, 11th&nbsp;digit denotes voltage</td>
<td>KEMET</td>
</tr><tr><td>250 VAC AC Rated Capacitors, CAN Series</td>
<td>CAN06 - CAN22 (0603 - 2220)</td>
<td>KEMET</td>
</tr><tr><td>High Reliability Alternative</td>
<td>CHAXXX</td>
<td>KEMET</td>
</tr><tr><td>KC-LINK</td>
<td>CKC33, CKC21, CKC18</td>
<td>KEMET</td>
</tr><tr><td>High Temperature 200°C Radial Ceramic Molded</td>
<td>C052H, C062H</td>
<td>KEMET</td>
</tr><tr><td>High Temperature C0G 175°C, 200°C Dielectric SMD</td>
<td>CXXXXH, "G" and "R" in the 6th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>High Temperature C0G 200°C Dielectric SMD</td>
<td>CXXXXH</td>
<td>KEMET</td>
</tr><tr><td>High Temperature C0G 260°C Dielectric SMD</td>
<td>CHTXXX</td>
<td>KEMET</td>
</tr><tr><td>X8L Dielectric 150°C SMD</td>
<td>N dielectric character in 12th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>X8R Dielectric 150°C SMD</td>
<td>H dielectric character in 12th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>X8G Dielectric 150°C SMD</td>
<td>T dielectric character in 12th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>High Voltage Goldmax 500V – 3kV</td>
<td>C3XX, C6XX</td>
<td>KEMET</td>
</tr><tr><td>High Voltage Floating Electrode (500V - 3kV)</td>
<td>CXXXX with "S" or "Y" in the 6th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>KPS Stacks</td>
<td>"1" or "2" in the 13th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>HiQ-CBR RF Capacitors</td>
<td>CBR02, CBR04, CBR06, CBR08</td>
<td>KEMET</td>
</tr><tr><td>Harsh Environment PME - High Voltage SMD Series</td>
<td>1206 - 6940</td>
<td>KEMET</td>
</tr><tr><td>Harsh Environment PME - C3 Technology Axial and Radial (125°C, 200°C, 260°C)</td>
<td>SCR/SCA, SRR/SRA, ACR/ACA, ARR/ARA, TCR/TCA, TRR/TRA</td>
<td>KEMET</td>
</tr><tr><td>Harsh Environment PME - HP Series, High Temperature, Leaded, 200°C</td>
<td>HPXX</td>
<td>KEMET</td>
</tr><tr><td>Harsh Environment PME - HS Series, Radial, Conformally Coated, 50 – 200 VDC (Space Grade)</td>
<td>XXHS</td>
<td>KEMET</td>
</tr><tr><td>Harsh Environment PME - SM Series, High Voltage, SMD, L and J Lead Frame</td>
<td>SM Series</td>
<td>KEMET</td>
</tr><tr><td>U2J Dielectric</td>
<td>"J" in the 12th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>KC-LINK with KONNEKT Technology</td>
<td>CKC with "L" in 13th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>KONNEKT Technology: C0G, X7R, U2J</td>
<td>CXXXX with "L" in 13th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>ESD Series C0G and X7R</td>
<td>CXXXX with "E" in 13th digit of part number</td>
<td>KEMET</td>
</tr><tr><td>X2Y Surface Mount EMI Filter Capacitors</td>
<td>CX</td>
<td>PULSE</td>
</tr><tr><td>Automotive Commodity</td>
<td>AC</td>
<td>YAGEO</td>
</tr><tr><td>Automotive High Capacitance ≥ 105</td>
<td>AC</td>
<td>YAGEO</td>
</tr><tr><td>Automotive High Voltage ≥ 500V</td>
<td>AC</td>
<td>YAGEO</td>
</tr><tr><td>Automotive High Temperature ≥ 150°C</td>
<td>AC</td>
<td>YAGEO</td>
</tr><tr><td>Automotive High Frequency</td>
<td>AQ</td>
<td>YAGEO</td>
</tr><tr><td>Automotive Soft Termination</td>
<td>AS</td>
<td>YAGEO</td>
</tr><tr><td>Automotive Array</td>
<td>AC Array</td>
<td>YAGEO</td>
</tr><tr><td>Specialty High Voltage ≥ 500V</td>
<td>HV</td>
<td>YAGEO</td>
</tr><tr><td>Specialty CBR</td>
<td>CQ</td>
<td>YAGEO</td>
</tr><tr><td>Specialty Soft Termination</td>
<td>CS</td>
<td>YAGEO</td>
</tr><tr><td>Specialty Array</td>
<td>Array</td>
<td>YAGEO</td>
</tr><tr><td>Specialty Safety</td>
<td>SC, ST</td>
<td>YAGEO</td>
</tr><tr><td>Specialty Low Inductance</td>
<td>CL</td>
<td>YAGEO</td>
</tr><tr><td>Specialty Others</td>
<td>Others</td>
<td>YAGEO</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span class="section-anchor" id="C6"> </span>
    Film
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table width="1080" cellpadding="1" border="0" cellspacing="0">
<tbody><tr><th style="text-align: left;" scope="col" width="45%">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th scope="col" style="text-align: left;" width="10%">Brand</th>
</tr><tr><td>Metallized Polyester Film Capacitor With Integrated Suppression Diode</td>
<td>F5A (5A)</td>
<td>KEMET</td>
</tr><tr><td>Metallized Polyester Film Capacitor With Integrated Suppression Diode</td>
<td>F5B (5B)</td>
<td>KEMET</td>
</tr><tr><td>Encapsulated Stacked Polyethylene Naphthalate (PEN) Surface Mount (Automotive)</td>
<td>LDE (DE)</td>
<td>KEMET</td>
</tr><tr><td>Encapsulated Polyphenylene Sulphide (PPS) Surface Mount</td>
<td>SMC (F125)</td>
<td>KEMET</td>
</tr><tr><td>Encapsulated Double Metallized Polyethylene Naphthalate (PEN) Surface Mount</td>
<td>GPC (F117)</td>
<td>KEMET</td>
</tr><tr><td>Encapsulated Stacked Polyphenylene Sulphide (PPS) Surface Mount</td>
<td>LDB (DB)</td>
<td>KEMET</td>
</tr><tr><td>Encapsulated Stacked Polyester (PET) Surface Mount (Automotive)</td>
<td>F161</td>
<td>KEMET</td>
</tr><tr><td>Unencapsulated Stacked Chip (PET) with Flat Terminations (Automotive)</td>
<td>JSN</td>
<td>KEMET</td>
</tr><tr><td>Encapsulated Double Metallized Polyphenylene Sulphide (PPS) Surface Mount</td>
<td>SPC</td>
<td>KEMET</td>
</tr><tr><td>Metallized Polypropylene, Pulse, Automotive</td>
<td>R75 (75)</td>
<td>KEMET</td>
</tr><tr><td>Metallized Polypropylene, Pulse, Automotive, High Temperature</td>
<td>R75H (75)</td>
<td>KEMET</td>
</tr><tr><td>Double Metallized Polypropylene, Pulse, Automotive</td>
<td>R76 (76)</td>
<td>KEMET</td>
</tr><tr><td>Double Metallized Polypropylene, Pulse, Automotive, High Temperature</td>
<td>R76H (76)</td>
<td>KEMET</td>
</tr><tr><td>Metallized Polyphenylene Sulfide, Pulse, and DC Transient Suppression</td>
<td>SMR (F211)</td>
<td>KEMET</td>
</tr><tr><td>Metallized Impregnated Paper</td>
<td>P295</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression (Automotive, Harsh Environment)</td>
<td>F862 V054, F863</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression, X2, High Temperature</td>
<td>R46_125C</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression, X1 (Automotive)</td>
<td>R47_X1</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression (Miniature, Automotive)</td>
<td>R52</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression (Miniature, Automotive)</td>
<td>R53</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression X2 (Automotive)</td>
<td>R53B</td>
<td>KEMET</td>
</tr><tr><td>Metallized Polypropylene, X1 (Automotive, Harsh Environment)</td>
<td>R58</td>
<td>KEMET</td>
</tr><tr><td>Metallized Polypropylene, Y1 (Automotive, Harsh Environment)</td>
<td>R4Y</td>
<td>KEMET</td>
</tr><tr><td>Metallized Polypropylene (Harsh Environment, Miniature, Automotive)</td>
<td>R41P</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression Y2 (Automotive)</td>
<td>R41</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression X1/Y2 (Miniature, Automotive)</td>
<td>R41B</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression, Y2, High Temperature (Automotive, Harsh Environment)</td>
<td>R41T</td>
<td>KEMET</td>
</tr><tr><td>EMI Suppression</td>
<td>SMP253 (P101), PME264 (P264), PME271Y (P271, P272), PME295 (P295)</td>
<td>KEMET</td>
</tr><tr><td>Metallized Impregnated Paper for EMI Suppression</td>
<td>PMR209 (P409)</td>
<td>KEMET</td>
</tr><tr><td>Metallized Impregnated Paper, X1, Integrated Resistor for EMI Suppression</td>
<td>PMR210</td>
<td>KEMET</td>
</tr><tr><td>Aluminum Can Power Film Capacitor for PFC &amp; AC Filter</td>
<td>C44P-R</td>
<td>KEMET</td>
</tr><tr><td>Box Types, Wire Terminals</td>
<td>C4AF, C4AS, C4AT</td>
<td>KEMET</td>
</tr><tr><td>Box Types, Wire Terminals, High Temperature, High Voltage</td>
<td>C4AK</td>
<td>KEMET</td>
</tr><tr><td>Box Types, Wire Terminals, High Capacitance, Automotive Grade</td>
<td>C4AQ</td>
<td>KEMET</td>
</tr><tr><td>Box Types, Wire Terminals, Miniaturized, Automotive Grade</td>
<td>C4AQ-M</td>
<td>KEMET</td>
</tr><tr><td>Box Types, Wire Terminals, Harsh Environment, Automotive Grade</td>
<td>C4AU</td>
<td>KEMET</td>
</tr><tr><td>Flat Execution, Stud Terminal, High Capacitance DC Link</td>
<td>C4DE</td>
<td>KEMET</td>
</tr><tr><td>Plastic Case Power Film Capacitor, Axial Terminals for GTO Clamping</td>
<td>C4DR</td>
<td>KEMET</td>
</tr><tr><td>High Capacitance DC Link, Male/Female Terminal</td>
<td>C44U-M</td>
<td>KEMET</td>
</tr><tr><td>Aluminum DC-Link Power Can, High Temperature</td>
<td>C44U-T</td>
<td>KEMET</td>
</tr><tr><td>Aluminum Can Power Film Capacitor for PFC &amp; AC Filter</td>
<td>C44P-R</td>
<td>KEMET</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span class="section-anchor" id="C7"> </span>
    Polymer
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table border="0" cellspacing="0" width="1080" cellpadding="1">
<tbody><tr><th scope="col" style="text-align: left;" width="45%">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th scope="col" style="text-align: left;" width="10%">Brand</th>
</tr><tr><td>Radial Solid Polymer Aluminum Capacitors</td>
<td>A750, A755, A758, A759</td>
<td>KEMET</td>
</tr><tr><td>Surface Mount Solid Polymer Aluminum Capacitors</td>
<td>A765, A766, A767, A768, A769, A770, A771</td>
<td>KEMET</td>
</tr><tr><td>AO-CAP High Temperature and High Humidity</td>
<td>A798</td>
<td>KEMET</td>
</tr><tr><td>Rectangular APL90</td>
<td>A992</td>
<td>KEMET</td>
</tr><tr><td>Rectangular APL9V</td>
<td>A993</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Axial PHA223</td>
<td>A286</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown PHH223</td>
<td>A894</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown SMD PHS223</td>
<td>A230</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown SMD PHV223</td>
<td>A233</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Axial PHA225</td>
<td>A891</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown PHH225</td>
<td>A291</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown SMD PHS225</td>
<td>A262</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown SMD PHV225</td>
<td>A264</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Axial PHA226</td>
<td>A292</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown PHH226</td>
<td>A892</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Axial PHA227</td>
<td>A293</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown PHH227</td>
<td>A893</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown SMD PHS227<br>
</td>
<td>A222</td>
<td>KEMET</td>
</tr><tr><td>Hybrid Radial Crown SMD PHV227<br>
</td>
<td>A223</td>
<td>KEMET</td>
</tr><tr><td>Surface Mount Hybrid Polymer Aluminum Capacitors</td>
<td>A780, A781, A782, A783, A784, A785, A787</td>
<td>KEMET</td>
</tr><tr><td>Radial Hybrid Polymer Aluminum Capacitors</td>
<td>A7C5</td>
<td>KEMET</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span class="section-anchor" id="C8"> </span>
    Supercapacitors
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table border="0" cellpadding="1" cellspacing="0" width="1080">
<tbody><tr><th style="text-align: left;" width="45%" scope="col">Description</th>
<th style="text-align: left;" scope="col">Series</th>
<th style="text-align: left;" width="10%" scope="col">Brand</th>
</tr><tr><td>Supercapacitors Automotive Grade</td>
<td>FMD, FMU, FU0H</td>
<td>KEMET</td>
</tr><tr><td>Surface Mount</td>
<td>FC</td>
<td>KEMET</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C9" class="section-anchor"> </span>
    Tantalum
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table width="1080" cellpadding="1" cellspacing="0" border="0">
<tbody><tr><th style="text-align: left;" width="45%" scope="col">Description</th>
<th style="text-align: left;" scope="col">Series</th>
<th width="10%" style="text-align: left;" scope="col">Brand</th>
</tr><tr><td>Polymer HRA for High Reliability Applications DLA 04051 and DLA 04052</td>
<td>T540, T541</td>
<td>KEMET</td>
</tr><tr><td>Polymer HRA</td>
<td>T543</td>
<td>KEMET</td>
</tr><tr><td>Reduced Leakage</td>
<td>T522</td>
<td>KEMET</td>
</tr><tr><td>Facedown Terminal</td>
<td>T523</td>
<td>KEMET</td>
</tr><tr><td>Facedown Termination Polymer SMD</td>
<td>T528</td>
<td>KEMET</td>
</tr><tr><td>500 Hours Load Humidity</td>
<td>T591</td>
<td>KEMET</td>
</tr><tr><td>AEC-Q200 (125°C) Facedown</td>
<td>T597</td>
<td>KEMET</td>
</tr><tr><td>AEC-Q200 (125°C)</td>
<td>T598</td>
<td>KEMET</td>
</tr><tr><td>AEC-Q200 (150°C)</td>
<td>T599</td>
<td>KEMET</td>
</tr><tr><td>High Energy</td>
<td>T545</td>
<td>KEMET</td>
</tr><tr><td>Tantalum Stack Polymer / MnO<sub>2</sub></td>
<td>TSP/TSM2, TSM3, TSM4, TSM6</td>
<td>KEMET</td>
</tr><tr><td>Polymer Hermetic Seal (PHS) / PHS Module</td>
<td>T550, T551, T555, T556, M55</td>
<td>KEMET</td>
</tr><tr><td>Reduced Leakage</td>
<td>T489</td>
<td>KEMET</td>
</tr><tr><td>Automotive 150°C</td>
<td>T498</td>
<td>KEMET</td>
</tr><tr><td>Automotive 175°C</td>
<td>T499</td>
<td>KEMET</td>
</tr><tr><td>High Temperature 200°C</td>
<td>T500</td>
<td>KEMET</td>
</tr><tr><td>High Temperature 230°C</td>
<td>T502</td>
<td>KEMET</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span id="C10" class="section-anchor"> </span>
    Circuit Protection
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellpadding="1" cellspacing="0" width="1080" border="0">
<tbody><tr><th style="text-align: left;" width="45%" scope="col">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th style="text-align: left;" scope="col" width="10%">Brand</th>
</tr><tr><td>TVS Diodes Automotive Grade</td>
<td>xxxxxxxx_AT</td>
<td>YAGEO</td>
</tr><tr><td>TVS Diodes - Low Capacitance Electrostatic Discharge Protection Devices</td>
<td>LA, LB, LE, LH, LT, SA, SB, SC, SD, SE, SF, SH, SJ, UA, UB, UC, UD, UE, UF</td>
<td>YAGEO</td>
</tr><tr><td>Gas Discharge Tubes</td>
<td>2R, 2RL, 2RM, 2RP, 3RL, 3RM, 3RP, 4532, B32</td>
<td>YAGEO</td>
</tr><tr><td>Spark Gap Protectors</td>
<td>BK</td>
<td>YAGEO</td>
</tr><tr><td>Thyristor Surge Suppressors</td>
<td>P, B, G</td>
<td>YAGEO</td>
</tr><tr><td>PPTCs</td>
<td>SMD, Leaded</td>
<td>YAGEO</td>
</tr><tr><td>NTCs</td>
<td>N, NT</td>
<td>YAGEO</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span class="section-anchor" id="C11"> </span>
    Discrete Semiconductors
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellpadding="1" width="1080" border="0" cellspacing="0">
<tbody><tr><th width="45%" scope="col" style="text-align: left;">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th scope="col" style="text-align: center;" width="14%">Brand</th>
</tr><tr><td>MOSFETs</td>
<td>All</td>
<td style="text-align: right;">YAGEO XSemi</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span id="C12" class="section-anchor"> </span>
    EMC Products
</h2>
</div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C13" class="section-anchor"> </span>
    Common Mode Chokes - Power
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellspacing="0" cellpadding="1" width="1080" border="0">
<tbody><tr><th width="30%" style="text-align: left;" scope="col">Description</th>
<th width="30%" style="text-align: left;" scope="col">Series</th>
<th width="10%" scope="col" style="text-align: left;">Brand</th>
<th style="text-align: left;" scope="col">KEMET Part Number</th>
</tr><tr><td>Common Mode SC Standard Coils</td>
<td>SC, SC 3PHASE, SC-D, SC-D-J/JH, SC-G/GS, SC-GJ, SC-J, SC-JH, SC-JKH, SC-JS, SC-JV</td>
<td>KEMET</td>
<td>UALSC__ (__ = 0, 1, 2, 3)</td>
</tr><tr><td>Common Mode SCR High Performance Coils</td>
<td>SCR, SCR22, SCR25, SCR31, SCR38, SCR47, SCR Three Phase, SCR-H</td>
<td>KEMET</td>
<td>UAL__ (__ = 20R, 30R, 40R, 50R, 60R, 71R, 81R, 91R, 01R, 151), UAL__ (__ = CA0, C61, CB1), UAL__ (__ = D71, DD1, E11, E21), UAL__ (__ = F11, FD1), UAL__ (__ = AC1, AD2, AE2, AG1, AH1), UAL__ (__ = BF1, BG1, BH1, BI1), UAL__ (__ = BA1, F21, G11, ID2, IF1, IG2), UAL__ (__ = F32, F40, F41)</td>
</tr><tr><td>Common Mode SCF High Performance Coils</td>
<td>SCF, SCF-J/JH, SCF Three Phase</td>
<td>KEMET</td>
<td>UAL__ (__ = SCF, F12, F19, F31, F33 or F47)</td>
</tr><tr><td>Common Mode SC-XV AEC-Q200 Automotive Grade Coils</td>
<td>SCR-XV, SCT-XV, SCF-XV, SCN-XV</td>
<td>KEMET</td>
<td>UALCR___ (___ = 19, 25, 29, 39), UALCT___ (___ = 19, 25, 29, 39), UALCF___(___=19, 25, 29, 39), UALCN35</td>
</tr><tr><td>Common Mode SU Standard Coils</td>
<td>SU7VC, SU9H, SU9HD, SU9HF, SU9V, SU9VD, SU9VF, SU10VFC-R, SU10VD, SU16VD</td>
<td>KEMET</td>
<td>UALSU7, UALSU9, UALSU1</td>
</tr><tr><td>Common Mode SS Standard Coils</td>
<td>SS11VL, SS21V, SS26V, SS30V, SSB11H-R, SSB11V-R</td>
<td>KEMET</td>
<td>UAL11V, UAL21V, UAL26V, UAL30V, UALB11</td>
</tr><tr><td>Common Mode SSR High Performance Coils</td>
<td>SSR10H, SSR10HS, SSR10V, SSR10VS, SSR21NH, SSR21NHS, SSR21NV, SSR21NVS, SSR21NH-M, SSR21NV-M, SSR21NHS-M, SSR21NVS-M</td>
<td>KEMET</td>
<td>UALR10, UALN21, UALM21, UALS21</td>
</tr><tr><td>Common Mode Coils for Power Line</td>
<td>SBS9080, SH, SHO</td>
<td>KEMET</td>
<td>UDLSBS9, UDLSH00, UDLSHO0</td>
</tr><tr><td>Common Mode SSRH High Performance Coils</td>
<td>SSRH7H-M, SSRH7HS-M, SSRH24NH, SSRH24NV, SSRH24NHS, SSRH24NVS</td>
<td>KEMET</td>
<td>UALSH7, UALS24</td>
</tr><tr><td>Common Mode Chokes Surface Mount and Through-Hole</td>
<td>PA3747, PA4053, PH9455, PA4040, PA441x, FE2X, PMC9539, PA2742NL, PA2741NL, PM0354, PAC6006, PM53913NL, PM2750NL, PM0351NL, PA5140, PM2754NL, PH9407, PA5141, PM0429NL, PM0502NL, PH9408,</td>
<td>Pulse</td>
<td>N/A</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C14" class="section-anchor"> </span>
    Common Mode Chokes - Signal
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table border="0" cellspacing="0" cellpadding="1" width="1080">
<tbody><tr><th style="text-align: left;" width="30%" scope="col">Description</th>
<th style="text-align: left;" scope="col" width="30%">Series</th>
<th style="text-align: left;" width="10%" scope="col">Brand</th>
<th scope="col" style="text-align: left;">KEMET Part Number</th>
</tr><tr><td>Common Mode Coils for Signal Line</td>
<td>M-500CT, SBT-01W, SPF</td>
<td>KEMET</td>
<td>UDLM000, UDLSBTW, UDLSPF0</td>
</tr><tr><td>Common Mode Device for HD-PLC</td>
<td>PLT</td>
<td>KEMET</td>
<td>UTXPLT</td>
</tr><tr><td>Common Mode Coils for Telephone Sets</td>
<td>ST, ST-110</td>
<td>KEMET</td>
<td>UDLST00</td>
</tr><tr><td>Common Mode Chokes (Non-Automotive)</td>
<td>B2005NL, PE-67531NL, PE-65554NL, PE-65950NL, B2013NL, B4003NL, BX8333NL, BX8333DNL, PE-65855NL, PE-68264NL, R0003NL, PE-56527NL, PE-65854NL, 23Z104SMNL, PE-65857NL, PE-67540NL, T8003NL, 23Z106SMNL, 23Z105SMNL, PE-69011NL, T81119NLT, TX8111NLT, T8116NLT, T8112NLT, T-8113NLT, T8114NLT</td>
<td>Pulse</td>
<td>N/A</td>
</tr><tr><td>Common Mode Chokes (Automotive)</td>
<td>AC1210-101-C, AC1210-101-D, AE2002, AE5002, AE0100, AE1210, AE3003, AE3005, AE3006, AWCU4543, AWCU3325, AWCU…-TE, PE-1812ACC110STS, PE-1812ACC220STS, PE-1812ACC510STS, PE-1812ACC101STS, AL0470B, AL0750B, AL1360B</td>
<td>Pulse</td>
<td>N/A</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C15" class="section-anchor"> </span>
    Differential Mode Chokes - Power
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table border="0" cellpadding="1" width="1080" cellspacing="0">
<tbody><tr><th scope="col" style="text-align: left;" width="30%">Description</th>
<th width="30%" scope="col" style="text-align: left;">Series</th>
<th style="text-align: left;" width="10%" scope="col">Brand</th>
<th scope="col" style="text-align: left;">KEMET Part Number</th>
</tr><tr><td>Differential Mode Standard Coils</td>
<td>SN, SN-J, SN-JA, SN-JB, SN-P2</td>
<td>KEMET</td>
<td>UALSN__ (__ = 1, 2, 3, 5, 8)</td>
</tr><tr><td>Differential Mode Coils/Boost and Smoothing Inductors</td>
<td>HHBC, PHBC, SHBC</td>
<td>KEMET</td>
<td>UALC__, UALP__, UALS__ (__ = 8S, 10, 12, 13, 14, 20, 4N or 4W)</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C16" class="section-anchor"> </span>
    Differential Mode Chokes - Signal
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table width="1080" border="0" cellpadding="1" cellspacing="0">
<tbody><tr><th scope="col" width="30%" style="text-align: left;">Description</th>
<th width="30%" scope="col" style="text-align: left;">Series</th>
<th scope="col" width="10%" style="text-align: left;">Brand</th>
<th style="text-align: left;" scope="col">KEMET Part Number</th>
</tr><tr><td>Differential Mode Coils for Power Line</td>
<td>SNT</td>
<td>KEMET</td>
<td>UDLSNT0</td>
</tr><tr><td>Differential Mode Coils for Signal Line</td>
<td>BEAD L, BEAD W, SBT</td>
<td>KEMET</td>
<td>UDLB000, UDLSBT0</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span class="section-anchor" id="C17"> </span>
    Dual Mode Chokes
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellpadding="1" width="1080" cellspacing="0" border="0">
<tbody><tr><th width="30%" style="text-align: left;" scope="col">Description</th>
<th width="30%" style="text-align: left;" scope="col">Series</th>
<th scope="col" width="10%" style="text-align: left;">Brand</th>
<th scope="col" style="text-align: left;">KEMET Part Number</th>
</tr><tr><td>Dual Mode Coils</td>
<td>SSHB10H, SSHB10HS, SSHB21H, SSHB21HS</td>
<td>KEMET</td>
<td>UALSB1, UALSB2</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C18" class="section-anchor"> </span>
    EMI Filters
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellspacing="0" border="0" width="1080" cellpadding="1">
<tbody><tr><th width="30%" scope="col" style="text-align: left;">Description</th>
<th style="text-align: left;" width="30%" scope="col">Series</th>
<th style="text-align: left;" width="10%" scope="col">Brand</th>
<th scope="col" style="text-align: left;">KEMET Part Number</th>
</tr><tr><td>Metal Box</td>
<td>GF, GT, LF</td>
<td>KEMET</td>
<td>UNFGF, UNFGT, UNFLF</td>
</tr><tr><td>Metal Box Inlet</td>
<td>GL</td>
<td>KEMET</td>
<td>UNFGL</td>
</tr><tr><td>Plastic Box</td>
<td>MA, MR, GTX</td>
<td>KEMET</td>
<td>UNFMA, UNFMR, UNFGX</td>
</tr><tr><td>Single Phase - FLLE2</td>
<td>FLLE</td>
<td>KEMET</td>
<td>N/A</td>
</tr><tr><td>Single Phase - FAM</td>
<td>FFAM</td>
<td>KEMET</td>
<td>N/A</td>
</tr><tr><td>Three Phase - FLLD3</td>
<td>FLLD</td>
<td>KEMET</td>
<td>N/A</td>
</tr><tr><td>Three Phase - FLLD4</td>
<td>FLLD</td>
<td>KEMET</td>
<td>N/A</td>
</tr><tr><td>Medical Equipment - FLLDU</td>
<td>FLLD</td>
<td>KEMET</td>
<td>N/A</td>
</tr><tr><td>Medical Equipment - FLLDH</td>
<td>FLLD</td>
<td>KEMET</td>
<td>N/A</td>
</tr><tr><td>Medical Equipment - FAH</td>
<td>FFAH</td>
<td>KEMET</td>
<td>N/A</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C19" class="section-anchor"> </span>
    EMI Suppression
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table width="1080" cellpadding="1" border="0" cellspacing="0">
<tbody><tr><th width="30%" style="text-align: left;" scope="col">Description</th>
<th width="30%" style="text-align: left;" scope="col">Series</th>
<th scope="col" style="text-align: left;" width="10%">Brand</th>
<th style="text-align: left;" scope="col">KEMET Part Number</th>
</tr><tr><td>Round Cable - Toroidal</td>
<td>ESD-R, ESD-R-B, ESD-R-H, ESD-R-SR, ESD-R-NC</td>
<td>KEMET</td>
<td>UECESDR, UECESDN</td>
</tr><tr><td>Round Cable - Snap-On</td>
<td>ESD-SR, ESD-SR-H, ESD-SR-HL</td>
<td>KEMET</td>
<td>UECESDS</td>
</tr><tr><td>Round Cable - Bead</td>
<td>B-20</td>
<td>KEMET</td>
<td>UECB200</td>
</tr><tr><td>Flat Cable - Solid</td>
<td>ESD-FPL</td>
<td>KEMET</td>
<td>UECESDF</td>
</tr><tr><td>Flat Cable - Split</td>
<td>ESD-FPD, ESD-FPD-1</td>
<td>KEMET</td>
<td>UECESDF</td>
</tr><tr><td>Noise Suppression Sheet and Tape</td>
<td>EFA, EFF4, EFG2, EFG3, EFS, EFW, EFX6, FF1, FG1, FG2, FX5, FS, FW5</td>
<td>KEMET</td>
<td>UFS__ (__ = EFA, EF4, EG2, EG3, EFS, EFW, EX6, FF1, FG1, FG2, FX5, FS0, FW5)</td>
</tr><tr><td>EMI Suppression Tape</td>
<td>ESTX, ESTV</td>
<td>KEMET</td>
<td>UFSESX, UFSESV</td>
</tr><tr><td>Magnetic Sheet</td>
<td>RFIDM4, RM4A</td>
<td>KEMET</td>
<td>UFSM40, UFSRM4</td>
</tr><tr><td>EMI Suppression Tape</td>
<td>EST</td>
<td>KEMET</td>
<td>UFSES</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span id="C20" class="section-anchor"> </span>
    Ground Wires
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table width="1080" cellpadding="1" cellspacing="0" border="0">
<tbody><tr><th width="30%" style="text-align: left;" scope="col">Description</th>
<th scope="col" style="text-align: left;" width="30%">Series</th>
<th scope="col" style="text-align: left;" width="10%">Brand</th>
<th scope="col" style="text-align: left;">KEMET Part Number</th>
</tr><tr><td>Earth Inductors</td>
<td>SNG</td>
<td>KEMET</td>
<td>UALSNG</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectionsubtitle">

<h5 data-smooth-scroll="">
    <span class="section-anchor" id="C21"> </span>
    Magnetic Materials
</h5></div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellspacing="0" width="1080" border="0" cellpadding="1">
<tbody><tr><th width="30%" scope="col" style="text-align: left;">Description</th>
<th scope="col" style="text-align: left;" width="30%">Series</th>
<th scope="col" style="text-align: left;" width="10%">Brand</th>
<th style="text-align: left;" scope="col">KEMET Part Number</th>
</tr><tr><td>Wireless Power Transfer (WPT) Ferrite Tiles</td>
<td>FPL</td>
<td>KEMET</td>
<td>UFCL</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span class="section-anchor" id="C22"> </span>
    Electromechanical
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellpadding="1" cellspacing="0" width="1080" border="0">
<tbody><tr><th style="text-align: left;" scope="col" width="45%">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th style="text-align: left;" scope="col" width="10%">Brand</th>
</tr><tr><td>Custom</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Lifting Magnets</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Magnetic Coils</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Relay Coils</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Shock Absorber Coils</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Solenoid Valves</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Trigger Magnetics</td>
<td>All</td>
<td>Pulse</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span id="C23" class="section-anchor"> </span>
    Inductors
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table width="1080" cellspacing="0" border="0" cellpadding="1">
<tbody><tr><th scope="col" width="30%" style="text-align: left;">Description</th>
<th style="text-align: left;" scope="col" width="30%">Series</th>
<th width="10%" style="text-align: left;" scope="col">Brand</th>
<th style="text-align: left;" scope="col">KEMET Part Number</th>
</tr><tr><td>Custom</td>
<td>All</td>
<td>Pulse</td>
<td>N/A</td>
</tr><tr><td>Power - METCOM SMD</td>
<td>MPX, MPXV, MPEV, MPGV</td>
<td>KEMET</td>
<td>UPI2</td>
</tr><tr><td>Power - SMD</td>
<td>MPCH, MPLCG, MPCV, MPLCV, TPI</td>
<td>KEMET</td>
<td>UPI__ (__ = C, E, V, T, Y)</td>
</tr><tr><td>Power - Through-Hole</td>
<td>SBC, SBCP</td>
<td>KEMET</td>
<td>UPIN, UPIO</td>
</tr><tr><td>Power</td>
<td>All</td>
<td>Pulse</td>
<td>N/A</td>
</tr><tr><td>RF Signal</td>
<td>All</td>
<td>Pulse</td>
<td>N/A</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span id="C24" class="section-anchor"> </span>
    Motor &amp; Ignition Coils
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellspacing="0" cellpadding="1" width="1080" border="0">
<tbody><tr><th width="45%" style="text-align: left;" scope="col">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th scope="col" style="text-align: left;" width="10%">Brand</th>
</tr><tr><td>Ignition Coils</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Motor Coils</td>
<td>All</td>
<td>Pulse</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span id="C25" class="section-anchor"> </span>
    Piezoelectric
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table border="0" cellspacing="0" cellpadding="1" width="1080">
<tbody><tr><th style="text-align: left;" width="30%" scope="col">Description</th>
<th style="text-align: left;" width="30%" scope="col">Series</th>
<th width="10%" style="text-align: left;" scope="col">Brand</th>
<th scope="col" style="text-align: left;">KEMET Part Number</th>
</tr><tr><td>Custom</td>
<td>All</td>
<td>KEMET</td>
<td>N/A</td>
</tr><tr><td>Piezoelectric Ceramic Actuators</td>
<td>AE, AER, AHB, AL, ASB, ASL</td>
<td>KEMET</td>
<td>UPAE0, UPAER, UPAHB, UPAL0, UPASB, UPASL</td>
</tr><tr><td>Piezo Ceramic Transducers</td>
<td>NBL, ND</td>
<td>KEMET</td>
<td>UPCNBL, UPCND0</td>
</tr><tr><td>Piezo Ceramic Acoustic Module</td>
<td>R11</td>
<td>KEMET</td>
<td>UAMR11</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span class="section-anchor" id="C26"> </span>
    Power Supplies
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table width="1080" border="0" cellspacing="0" cellpadding="1">
<tbody><tr><th width="45%" style="text-align: left;" scope="col">Description</th>
<th style="text-align: left;" scope="col">Series</th>
<th scope="col" width="10%" style="text-align: left;">Brand</th>
</tr><tr><td>AC to DC</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Custom</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>DC to DC</td>
<td>All</td>
<td>Pulse</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span id="C27" class="section-anchor"> </span>
    Resistors
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table cellpadding="1" cellspacing="0" width="1080" border="0">
<tbody><tr><th scope="col" style="text-align: left;" width="45%">Description</th>
<th style="text-align: left;" scope="col">Series</th>
<th width="10%" style="text-align: left;" scope="col">Brand</th>
</tr><tr><td>Automotive Thin Film</td>
<td>RP, NT, VT</td>
<td>YAGEO</td>
</tr><tr><td>Metal</td>
<td>PA, PE, PS, PU</td>
<td>YAGEO</td>
</tr><tr><td>Anti-FOS</td>
<td>AA,AF</td>
<td>YAGEO</td>
</tr><tr><td>Anti-Surge</td>
<td>SR</td>
<td>YAGEO</td>
</tr><tr><td>High Voltage</td>
<td>RV, HV</td>
<td>YAGEO</td>
</tr><tr><td>Precision</td>
<td>RE</td>
<td>YAGEO</td>
</tr><tr><td>Fusible Wirewound Moulded</td>
<td>BWF</td>
<td>Vitrohm</td>
</tr><tr><td>General Purpose Wirewound Moulded</td>
<td>BWS</td>
<td>Vitrohm</td>
</tr><tr><td>Safety UL Approved Wirewound Coated UL1412</td>
<td>CRF</td>
<td>Vitrohm</td>
</tr><tr><td>Pulse Wirewound Coated</td>
<td>CRP</td>
<td>Vitrohm</td>
</tr><tr><td>Precision Wirewound Coated</td>
<td>CRS</td>
<td>Vitrohm</td>
</tr><tr><td>Current Sensor EBW Metal Strip Open Frame AEC-Q200</td>
<td>CSB, CSC, CSD, CSM, CST</td>
<td>Vitrohm</td>
</tr><tr><td>Power and Pulse Wirewound Ceramic Case</td>
<td>KHS</td>
<td>Vitrohm</td>
</tr><tr><td>Current Sensor Flat Wire Ceramic Case</td>
<td>KNC</td>
<td>Vitrohm</td>
</tr><tr><td>Current Sensor Flat Wire Open Frame AEC-Q200</td>
<td>KNS</td>
<td>Vitrohm</td>
</tr><tr><td>General Purpose Wirewound Coated</td>
<td>KPS</td>
<td>Vitrohm</td>
</tr><tr><td>Power and Pulse Wirewound Ceramic Case</td>
<td>KVS</td>
<td>Vitrohm</td>
</tr><tr><td>Power Wirewound Ceramic Case</td>
<td>KWA</td>
<td>Vitrohm</td>
</tr><tr><td>Power Wirewound Ceramic Case</td>
<td>KWP</td>
<td>Vitrohm</td>
</tr><tr><td>Power Ceramic Case</td>
<td>KWV</td>
<td>Vitrohm</td>
</tr><tr><td>General Purpose Metal Oxide Coated</td>
<td>POS</td>
<td>Vitrohm</td>
</tr><tr><td>Power Wirewound Aluminum Case</td>
<td>REA</td>
<td>Vitrohm</td>
</tr><tr><td>Precision Wirewound Moulded</td>
<td>RWC</td>
<td>Vitrohm</td>
</tr><tr><td>Fusible Wirewound Moulded</td>
<td>RWF</td>
<td>Vitrohm</td>
</tr><tr><td>Pulse Wirewound Moulded</td>
<td>RWI</td>
<td>Vitrohm</td>
</tr><tr><td>Current Sensor Flat Wire Moulded</td>
<td>RWN</td>
<td>Vitrohm</td>
</tr><tr><td>Power Metal Film Moulded</td>
<td>RWP</td>
<td>Vitrohm</td>
</tr><tr><td>Safety Wirewound Moulded</td>
<td>RWS</td>
<td>Vitrohm</td>
</tr><tr><td>Power Wirewound Aluminum Case</td>
<td>RXL</td>
<td>Vitrohm</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span id="C28" class="section-anchor"> </span>
    Sensors
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table border="0" cellspacing="0" cellpadding="1" width="1080">
<tbody><tr><th width="30%" style="text-align: left;" scope="col">Description</th>
<th scope="col" style="text-align: left;" width="30%">Series</th>
<th style="text-align: left;" width="10%" scope="col">Brand</th>
<th style="text-align: left;" scope="col">KEMET Part Number</th>
</tr><tr><td>Current - CT, C/CT, MR, LA12, FG</td>
<td>&nbsp;</td>
<td>KEMET</td>
<td>USEN, USEX, USEZ, USEL, USET</td>
</tr><tr><td>Current Sense Transformers</td>
<td>P820x, PA1005, PM2165, PA0368, PH9494, PH9505, PH9500, PE-682xx, PB002x, PAS6322, PMS6322 , PE-67xxx, P058x, FIS1x1, FIS1xx5, PE-5168x, PE-5171x, PE-6358x, PE-6361x, PE-64xxx</td>
<td>Pulse</td>
<td>N/A</td>
</tr><tr><td>Custom</td>
<td>All</td>
<td>KEMET, Pulse, YAGEO Nexensos</td>
<td>N/A</td>
</tr><tr><td>Flame Detection</td>
<td>QFC, QFCE, QFS</td>
<td>KEMET</td>
<td>USEQFC, USEQFCE, USEQFS</td>
</tr><tr><td>Food Detection&amp; General IR Spectroscopy</td>
<td>QDA, QDC</td>
<td>KEMET</td>
<td>USEQDA, USEQDC</td>
</tr><tr><td>Gas Detection</td>
<td>QGC, QGS</td>
<td>KEMET</td>
<td>USEQGC, USEQGS</td>
</tr><tr><td>Motion Detection</td>
<td>QMS</td>
<td>KEMET</td>
<td>USEQMS</td>
</tr><tr><td>Platinum Resistance Temperature Detector (RTD) Sensor Assemblies</td>
<td>MR, PCB, all others</td>
<td>YAGEO Nexensos</td>
<td>N/A</td>
</tr><tr><td>Platinum Resistance Temperature Detector (RTD) Sensor Elements</td>
<td>C, H, HL, L, LN, M, SMD</td>
<td>YAGEO Nexensos</td>
<td>N/A</td>
</tr><tr><td>Proximity</td>
<td>PL, SS</td>
<td>KEMET</td>
<td>USEY, USES</td>
</tr><tr><td>Thermal Reed Switch</td>
<td>OHD, TRS</td>
<td>KEMET</td>
<td>USEO, USE__ (__ = C, D, E, F, G, H or I)</td>
</tr><tr><td>Vibration</td>
<td>VS</td>
<td>KEMET</td>
<td>USEV</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span class="section-anchor" id="C29"> </span>
    Signal Magnetics &amp; Connectors
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table width="1080" cellspacing="0" cellpadding="1" border="0">
<tbody><tr><th scope="col" style="text-align: left;" width="45%">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th width="10%" style="text-align: left;" scope="col">Brand</th>
</tr><tr><td>Automotive Networks</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Cages</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Connectors</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Ethernet (LAN)</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Integrated Connector Modules (ICMs)</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Telecom &amp; Audio (WAN)</td>
<td>All</td>
<td>Pulse</td>
</tr></tbody></table>

</div></div>


    
    
    <div class="sectiontitle">

<h2 data-smooth-scroll="">
    <span class="section-anchor" id="C30"> </span>
    Transformers
</h2>
</div>


    
    
    <div class="rte">
<div class="rte-wrapper  kemet-component__spacing-below--sm ">
        <table border="0" width="1080" cellspacing="0" cellpadding="1">
<tbody><tr><th scope="col" style="text-align: left;" width="45%">Description</th>
<th scope="col" style="text-align: left;">Series</th>
<th style="text-align: left;" width="10%" scope="col">Brand</th>
</tr><tr><td>Custom</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Power</td>
<td>All</td>
<td>Pulse</td>
</tr><tr><td>Isolation</td>
<td>All</td>
<td>Pulse</td>
</tr></tbody></table>

</div></div>



        </div>
    </div>
    <script>
        $(".datasheet-menu__list").find("a").on('click',function(){$(".datasheet-menu__accordion-title")[0].click();});
    </script>
</div>

</div>`;
